import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoublePipeHeatExchanger = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 90,
	height: 50,
	viewBox: "0 0 90.0 50.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 5,
			width: 70,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 35,
			width: 70,
			height: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 10.0 L 75.0 10.0 A 15.0 15.0 0.0 1 1 75.0 40.0 L 0.0 40.0 M 10.0 0.0 L 10.0 5.0 M 8.0 0.0 L 12.0 0.0 M 0.0 8.0 L 0.0 12.0 M 0.0 38.0 L 0.0 42.0 M 10.0 45.0 L 10.0 50.0 M 8.0 50.0 L 12.0 50.0 M 70.0 15.0 L 70.0 35.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgDoublePipeHeatExchanger;
